import { userConstants } from '../constants'

export const RegChangePass = (state = {}, action) => {
    switch (action.type) {
        case userConstants.REGISTER_CHANGEPASS_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case userConstants.REGISTER_CHANGEPASS_SUCCESS:
            return {
                loading: false,
                items: action.registerCPassData.Body,
                error: undefined
            }
            
        case userConstants.REGISTER_CHANGEPASS_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const RecoverChangePassword = (state = {}, action) => {
    switch (action.type) {
        case userConstants.RECOVER_PASSWORD_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case userConstants.RECOVER_PASSWORD_SUCCESS:
            return {
                loading: false,
                items: action.registerCPassData.Body,
                error: undefined
            }
            
        case userConstants.RECOVER_PASSWORD_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}